export default function AHamburgerButton({ onMenuToggle }: { onMenuToggle: () => void }) {
	return (
		<button
			className='header__hamburger-button'
			onClick={onMenuToggle}
			name='menu'
			title='Menu'
		>
			<svg className='sicofill'>
				<use href='/assets/layout/icons.svg#s_menu' />
			</svg>
		</button>
	)
}
